import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row mb-3",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_2 = { style: {"flex":"0 0 66.66%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%","display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"4px","font-size":"0.8rem"} }, " Mẫu số 02-VT "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"4px","font-size":"0.8rem"} }, " (Ban hành theo QĐ số: 200/2014/TT-BTC "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"0","font-size":"0.8rem"} }, " Ngày 22/12/2014 của Bộ trưởng BTC) ")
], -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  class: "row mb-3",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%"} }, null, -1)
const _hoisted_7 = { style: {"flex":"0 0 33.33%","text-align":"center"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-weight":"bold","margin-bottom":"8px"} }, " PHIẾU NHẬP KHO ", -1)
const _hoisted_9 = { style: {"margin-bottom":"4px","font-style":"italic"} }
const _hoisted_10 = { style: {"margin-bottom":"0"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%"} }, null, -1)
const _hoisted_12 = { style: {"font-size":"0.9rem","margin-bottom":"1rem"} }
const _hoisted_13 = { style: {"margin-bottom":"8px"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "Họ, tên người giao:", -1)
const _hoisted_15 = { style: {"margin-left":"8px"} }
const _hoisted_16 = { style: {"margin-bottom":"12px"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"4px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Theo hợp đồng:")
], -1)
const _hoisted_18 = { style: {"margin-bottom":"4px","white-space":"pre-wrap"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("      - "), -1)
const _hoisted_20 = { style: {"margin":"0 1.5rem"} }
const _hoisted_21 = { style: {"margin-bottom":"0","white-space":"pre-wrap"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("      - "), -1)
const _hoisted_23 = { style: {"margin":"0 1.5rem"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"4px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Theo hóa đơn:")
], -1)
const _hoisted_25 = { style: {"margin-bottom":"0","white-space":"pre-wrap"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("      - "), -1)
const _hoisted_27 = { style: {"margin":"0 1.5rem"} }
const _hoisted_28 = { style: {"margin-bottom":"8px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Đối tác:", -1)
const _hoisted_30 = { style: {"margin-left":"8px"} }
const _hoisted_31 = { style: {"margin-bottom":"8px"} }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Nhập tại kho:", -1)
const _hoisted_33 = { style: {"margin-left":"8px"} }
const _hoisted_34 = { style: {"margin-bottom":"0"} }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, "Trạng thái:", -1)
const _hoisted_36 = { style: {"margin-left":"8px"} }
const _hoisted_37 = {
  class: "pdf-print-table",
  style: {"font-size":"0.8rem","margin-bottom":"1rem"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, "TT"),
    /*#__PURE__*/_createElementVNode("th", null, " Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa "),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Mã vật tư"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "ĐVT"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Thành tiền")
  ])
], -1)
const _hoisted_39 = { style: {"text-align":"left"} }
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = { style: {"text-align":"center"} }
const _hoisted_42 = { style: {"text-align":"right"} }
const _hoisted_43 = { style: {"text-align":"right"} }
const _hoisted_44 = { style: {"text-align":"right"} }
const _hoisted_45 = { class: "pdf-print-table-total-row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tổng cộng")
], -1)
const _hoisted_47 = { style: {"text-align":"right"} }
const _hoisted_48 = { style: {"text-align":"right","margin-bottom":"1.5rem","word-break":"break-word"} }
const _hoisted_49 = { style: {"font-style":"italic"} }
const _hoisted_50 = { style: {"display":"flex","justify-content":"space-around","margin-top":"2rem"} }
const _hoisted_51 = { style: {"text-align":"center","font-weight":"bold","margin":"0 0 4px"} }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin":"0","font-size":"0.8rem"} }, " (Ký, họ tên) ", -1)
const _hoisted_53 = {
  key: 0,
  style: {"text-align":"center","margin":"0","text-transform":"capitalize"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_PdfAccountingHeader = _resolveComponent("PdfAccountingHeader")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Phiếu nhập kho",
    "title-suffix": _ctx.phieuNhapData?.so_phieu,
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "fallback-route-name": "chi-tiet-phieu-nhap-kho"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "phieu-nhap-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.phieuNhapData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "printing-paper",
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_PdfDocumentHeader, {
                    "ten-don-vi": _ctx.tenDonVi,
                    "ten-don-vi-cha": _ctx.tenDonViCha
                  }, null, 8, ["ten-don-vi", "ten-don-vi-cha"])
                ]),
                _hoisted_3
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_PdfAccountingHeader, {
                  "tai-khoan-no": _ctx.taiKhoanNo,
                  "tai-khoan-co": _ctx.taiKhoanCo
                }, null, 8, ["tai-khoan-no", "tai-khoan-co"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.ngayNhapKhoDisplay), 1),
                  _createElementVNode("p", _hoisted_10, [
                    _createTextVNode(" Phiếu nhập kho số: "),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.phieuNhapData.so_phieu), 1)
                  ])
                ]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.phieuNhapData.nguoi_giao), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.phieuNhapData.id_hop_dong != 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_17,
                        _createElementVNode("p", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", null, "Số hợp đồng: " + _toDisplayString(_ctx.soHopDongDisplay), 1),
                          _createElementVNode("span", _hoisted_20, "Ngày hợp đồng: " + _toDisplayString(_ctx.ngayHopDongDisplay), 1)
                        ]),
                        _createElementVNode("p", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("span", null, "Số hóa đơn: " + _toDisplayString(_ctx.phieuNhapData.so_hoa_don || ""), 1),
                          _createElementVNode("span", _hoisted_23, "Ngày hóa đơn: " + _toDisplayString(_ctx.ngayHoaDonDisplay), 1)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_24,
                        _createElementVNode("p", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("span", null, "Số hóa đơn: " + _toDisplayString(_ctx.phieuNhapData.so_hoa_don || ""), 1),
                          _createElementVNode("span", _hoisted_27, "Ngày hóa đơn: " + _toDisplayString(_ctx.ngayHoaDonDisplay), 1)
                        ])
                      ], 64))
                ]),
                _createElementVNode("p", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.tenTkCoDisplay), 1)
                ]),
                _createElementVNode("p", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.phieuNhapData.kho.ten_kho), 1)
                ]),
                _createElementVNode("p", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.phieuNhapData.is_approved ? "Đã duyệt" : "Chưa duyệt"), 1)
                ])
              ]),
              _createElementVNode("table", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phieuNhapData.vat_tu_nhap_kho, (vatTu, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: vatTu.id,
                      class: _normalizeClass({
                'pdf-print-table-data-row': true,
                'pdf-print-table-data-row--last':
                  index === _ctx.phieuNhapData.vat_tu_nhap_kho.length - 1,
              })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(vatTu.ten_vat_tu), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(vatTu.ma_vat_tu), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(vatTu.don_vi_tinh), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatUnitPrice(vatTu.pivot.don_gia)), 1),
                      _createElementVNode("td", _hoisted_44, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
                    _ctx.calcLineAmount(+vatTu.pivot.don_gia, +vatTu.pivot.so_luong)
                  )), 1)
                      ])
                    ], 2))
                  }), 128)),
                  _createElementVNode("tr", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("td", _hoisted_47, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(_ctx.totalPrice)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createTextVNode(" Tổng số tiền (viết bằng chữ): "),
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.tongTienInText), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatureItems, (sig) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: sig.label,
                    style: {"display":"inline-flex","flex-direction":"column","align-items":"center","height":"120px","justify-content":"space-between"}
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_51, _toDisplayString(sig.label), 1),
                      _hoisted_52
                    ]),
                    (sig.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(sig.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title-suffix", "source", "file-name", "loading"]))
}